import '../inventory/grn/grnDetail.css';
import { formatDate } from '../../util/helper';
import { Table, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { get } from '../../services/apiController';
import { DownloadIcon } from '../vm/components/icons';

const BreakdownDetail = ({ data }) => {
    const [factory, setFactory] = useState({});
    const branchId = data.factoryId;
    useEffect(() => {
        if (branchId) {
            get('/branches/?id=' + branchId).then((branch) => {
                if (branch.data.rows.length) {
                    setFactory(branch.data.rows[0]);
                }
            });
        }
    }, [branchId]);

    return (
        <div className={`grn-detail`}>
            <div className="text-center">
                <div className="mb-3">
                    <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
                    <h6 className="m-0" style={{ fontSize: '11px' }}>
                        {factory?.name}
                        <br />
                        {factory?.address}
                    </h6>
                </div>
                <div>
                    <h5 className="mb-2">
                        <b>
                            <u>Breakdown Details</u>
                        </b>
                    </h5>
                </div>
            </div>
            <Table bordered striped responsive className="mt-3">
                <tbody>
                    <tr>
                        <th>Machine Name</th>
                        <td>{data?.model}</td>
                        <th>Machine Type</th>
                        <td>{data?.section}</td>
                        <th>Break Date</th>
                        <td>{formatDate(data?.breakDate)}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>{data?.status}</td>
                        <th>Reason</th>
                        <td>{data?.reason}</td>
                        {data.status === 'REPAIRED' ? (
                            <>
                                <th>Technician Name</th>
                                <td>{data?.technicianName}</td>
                            </>
                        ) : (
                            <>
                                <td></td>
                            </>
                        )}
                    </tr>
                    {data.status === 'REPAIRED' ? (
                        <>
                            <tr>
                                <th>Technician Number</th>
                                <td>{data?.technicianContactNumber}</td>
                                <th>Serviced Date</th>
                                <td>{formatDate(data?.servicedDate)}</td>
                                <th>Service Comments</th>
                                <td>{data?.serviceComments ?? 'NA'}</td>
                            </tr>
                            <tr>
                                <th>Labour Cost</th>
                                <td>{data?.serviceCost ?? 'NA'}</td>
                                <th>Material Cost</th>
                                <td>{data?.materialCost ?? 'NA'}</td>
                                <th>Supervised By</th>
                                <td>{data?.supervisedBy ?? 'NA'}</td>
                            </tr>
                        </>
                    ) : ('')}
                </tbody>
            </Table>
            {data.file_1 || data.file_2 || data.file_3 || data.file_4 || data.file_5 || data.file_6 || data.file_7 || data.file_6 || data.file_9 || data.file_10 ? (
                <>
                    <div className="text-left">
                        <div>
                            <h6 className="mb-2">
                                <b>
                                    Breakdown Documents
                                </b>
                            </h6>
                        </div>
                    </div>
                    <Row>
                        {data.file_1 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_1}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_1}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}

                        {data.file_2 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_2}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_2}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_3 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_3}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_3}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_4 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_4}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_4}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_5 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_5}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_5}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_6 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_6}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_6}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_7 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_7}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_7}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_8 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_8}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_8}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_9 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_9}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_9}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                        {data.file_10 ? (
                            <>
                                <Col xs={3} className="file-name">
                                    {data?.file_10}
                                </Col>
                                <Col xs={1} className="text-center actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${data?.file_10}`}>
                                        <DownloadIcon />
                                    </a>
                                </Col>
                            </>
                        ) : ('')}
                    </Row>
                </>
            ) : ('')}
            {data.sparesInfo && data.sparesInfo.length > 0 ? (
                <>
                    <Table striped bordered className="text-center grn-detail-table">
                        <thead>
                            <tr>
                                <th className="p-0.5">Sl No.</th>
                                <th className="p-05">Spare Name</th>
                                <th className="p-05">Numbers</th>
                                <th className="p-05">Price/Unit</th>
                                <th className="p-05">Labour Cost</th>
                                <th className="p-05">Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.sparesInfo?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="p-05">{index + 1}</td>
                                        <td className="p-05">{item?.spareName}</td>
                                        <td className="p-05">{item?.numbers}</td>
                                        <td className="p-05">{item?.price}</td>
                                        <td className="trp-5">{item?.labourCost}</td>
                                        <td className="p-05">{item?.totalAmount}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                    <div className="total-amount">
                        <p style={{ fontWeight: 'bold' }}>
                            <span>Sub-Total</span>
                            <span style={{ marginLeft: '35px' }}>{data?.subTotal}</span>
                        </p>
                    </div>
                </>
            ) : ('')}
        </div>
    );
};

export default BreakdownDetail;
